// src/pages/LoginPage/LoginPage.tsx

import React, { useState, useContext } from "react";
import styles from "./LoginPage.module.scss";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import api from "../../api/client";
import { AuthContext } from "../../context/AuthContext";

const LoginPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setIsAuthenticated } = useContext(AuthContext);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async (event: React.FormEvent) => {
    event.preventDefault();

    try {
      // 调用后端登录API
      const res = await api.post(
        "/login",
        {
          username,
          password,
        },
        {
          withCredentials: true, // 确保请求携带 Cookie
        }
      );

      if (res.status === 200) {
        setIsAuthenticated(true);
        navigate("/customer_management");
      } else {
        alert(t("login.invalidCredentials"));
      }
    } catch (error) {
      console.error("Login failed:", error);
      alert(t("login.invalidCredentials"));
    }
  };

  return (
    <div className={styles.loginPage}>
      <div className={styles.loginContainer}>
        <h1>{t("login.title")}</h1>
        <form onSubmit={handleLogin} className={styles.loginForm}>
          <label className={styles.formLabel}>
            {t("login.username")}
            <input
              type="text"
              name="username"
              required
              className={styles.inputField}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </label>
          <label className={styles.formLabel}>
            {t("login.password")}
            <input
              type="password"
              name="password"
              required
              className={styles.inputField}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          <button type="submit" className={styles.submitButton}>
            {t("login.submit")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
